import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Heart, MessageCircle, User, Settings } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const BottomNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { translate } = useLanguage();

  const navItems = [
    { icon: Home, label: translate('nav.home'), path: '/' },
    { icon: Heart, label: translate('nav.matches'), path: '/matches' },
    { icon: MessageCircle, label: translate('nav.chat'), path: '/chat' },
    { icon: User, label: translate('nav.profile'), path: '/profile' },
    { icon: Settings, label: translate('nav.settings'), path: '/settings' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white/90 dark:bg-gray-800/90 backdrop-blur-lg border-t border-purple-200 dark:border-gray-700">
      <div className="flex justify-around items-center py-2 px-4">
        {navItems.map(({ icon: Icon, label, path }) => {
          const isActive = location.pathname === path || 
            (path === '/chat' && location.pathname.startsWith('/chat'));
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={`flex flex-col items-center py-2 px-3 rounded-lg transition-all duration-200 ${
                isActive 
                  ? 'text-purple-600 dark:text-purple-400 bg-purple-100 dark:bg-purple-900/30' 
                  : 'text-gray-600 dark:text-gray-400 hover:text-purple-500 dark:hover:text-purple-400'
              }`}
            >
              <Icon size={20} />
              <span className="text-xs mt-1">{label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default BottomNavigation;